import { __decorate } from "tslib";
import { SalesChannel } from '@/helpers/entities/enums/v2/SalesChannel';
import { textTruncate } from '@/helpers/text_truncate';
import { Component, Vue } from 'vue-property-decorator';
let ReferralLinkMixin = class ReferralLinkMixin extends Vue {
    refLinkBuilder(code, fbPageId, salesChannel, app) {
        if (salesChannel === SalesChannel.instagram) {
            return `ig.me/m/${app.instagramUsername}?ref=${code}`;
        }
        if (salesChannel === SalesChannel.glife) {
            // Change this if you want to Test ot UAT
            return `https://gcashapp.page.link/?link=https%3A%2F%2Fgcash.splashscreen%2F%3Fredirect%3Dgcash%253A%252F%252Fcom.mynt.gcash%252Fapp%252F006300121300%253FappId%253D${app.gcashAppId}%2526page%253Dpages%252Fauth%252Fauth%253FrefLink%253D${code}&apn=com.globe.gcash.android&isi=520020791&ibi=com.globetel.gcash`;
            //
            // return `https://gcashdev.page.link/?link=https%3A%2F%2Fgcash.splashscreen%2F%3Fredirect%3Dgcash%253A%252F%252Fcom.mynt.gcash%252Fapp%252F006300121300%253FappId%253D${app.gcashAppId}%2526page%253Dpages%252Fauth%252Fauth%253FrefLink%253D${code}&apn=com.globe.gcash.android.uat.tokyo&ibi=xyz.mynt.gcashdev&efr=1`;
        }
        return `m.me/${fbPageId}?ref=${code}`;
    }
    truncateLink(code, fbPageId, salesChannel, app) {
        return textTruncate(this.refLinkBuilder(code, fbPageId, salesChannel, app), 30);
    }
};
ReferralLinkMixin = __decorate([
    Component
], ReferralLinkMixin);
export default ReferralLinkMixin;
